import { MyReferral } from "../../components/MyReferral/MyReferral";

/** Route wrapper; `MyReferral` renders its own `zs-page` layout. */
export const MyReferralPage = () => {
  return <MyReferral />;
};
